import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
    selector: 'app-terms-conditions',
    imports: [RouterLink, RouterLinkActive],
    templateUrl: './terms-conditions.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./terms-conditions.component.scss'],
})
export class TermsConditionsComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}
